'use client';

import { useIntl } from 'react-intl';
import {
  PriceValue,
  type PriceValueProps,
} from '@packages/shared/src/ui/Price/PriceValue/PriceValue';
import { priceValueMessages } from './messages';

type PriceValueLocalizedProps = Omit<PriceValueProps, 'aria-label'>;

export const PriceValueLocalized = (props: PriceValueLocalizedProps) => {
  const { formatMessage } = useIntl();

  return <PriceValue {...props} aria-label={formatMessage(priceValueMessages.currentPrice)} />;
};
